import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints } from '@/styles'
import { Button } from '@/components/button'
import editIcon from './edit-icon.svg'

const StyledButton = styled(Button)`
  gap: 0 8px;
  border-radius: 4px;
`

const EditButton = ({ listingId, style }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.phoneMax})`)
  const padding = isMobile ? '8px 16px' : '12px 20px'

  return (
    <StyledButton
      minHeight="44px"
      minWidth="82px"
      padding={padding}
      theme="secondary"
      size="small"
      onClick={() => history.push(`/listing/edit/${listingId}`)}
      id="listing-dashboard-edit-click"
      style={style}
    >
      <img src={editIcon} alt="" />
      {t('common.edit', 'Edit')}
    </StyledButton>
  )
}

export default EditButton
